import Vue from 'vue'

import VueParticles from 'vue-particles'
import App from './App'
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
import Login from './views/Login.vue'
import Home from './views/Home.vue'
import Workspace from './components/Workspace.vue'
import Vuetify from 'vuetify'
import VueRouter from 'vue-router'
import {routes} from './routes'
import Toastr from "vue-toastr"
import "vuetify/dist/vuetify.min.css";
import "vue-toastr/src/vue-toastr.scss"
import {store} from './store.js'
import Emitter from 'tiny-emitter'

Vue.use(VueParticles);
Vue.use(Toastr);
Vue.use(Vuetify);
Vue.use(VueRouter);

Vue.component('ltpbase-header', Header);
Vue.component('ltpbase-footer', Footer);
Vue.component('ltpbase-workspace', Workspace);
Vue.component('ltpbase-home', Home);
Vue.component('ltpbase-login', Login);

window.Vue = Vue;

const router = new VueRouter({
  routes,
  mode: 'history'
});

Vue.config.productionTip = false;
Vue.prototype.$emitter = new Emitter()
Vue.prototype.$msalInstance = {}

new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js